import { useModel, useRoute } from "@bcm-dev/bcms-vite";
import { useMultiPay } from "compid/workflows/MultiPay";
import { Autopay, Bill, Payment } from "model/";

import ButtonContainer from "compid/shared/containers/ButtonContainer";
import BillerView from "compid/shared/views/BillerView";
import UIButton from "compid/ui/UIButton";
import UICheckbox from 'compid/ui/UICheckbox';
import BottomPaymentInfo from "../BottomPaymentInfo";

export default function PaidUpcomingBillerView(props) {
    const { payments } = useModel();
    const { toggleAdd, state, submit } = useMultiPay();
    const navigate = useRoute();
   
    const addedBillerViewIDs = [];
    const { scheduled, processed, processing, canceled } = Bill.initAll().reduce((result, bill) => {
        const lastPayment = Payment.getLastPaymentByBillerID(bill.biller.id, payments);

        const isIncluded = state.includes(bill.id);
        const shouldDisable = state.length > 0;

        const disabledClass = shouldDisable ? "disabled-gray" : "";
        const billerIsAdded = bill.biller.addType !== "quick_add" && bill.biller.addType !== "verification_add";

        const onClick = evt => !shouldDisable
            ? navigate(`/makeAPayment/${ bill.id }`)
            : undefined;

        const billerValidStatus = bill.status.toLowerCase() !== "due";
        const billerID = bill.biller.id;
        const hasAutopays = Autopay.initAll().filter(item => item.billerID === bill.biller.id).length > 0;
        // A biller can have multiple bills.
        // If any of those bills are "due", do not show this biller here.
        const billerHasDueBills = Bill.initAll().filter(bill => {
            if( bill.biller.id === billerID){
               if(bill.status.toLowerCase() === "due"){
                       if (bill.reminder){
                           return  bill.reminder.daysToRemindMeInAdvanced > bill.reminder.dueDate.diff()
                       }
                       return true
               }
            }  
return false;
           }).length > 0;
        const didAddBillerView = addedBillerViewIDs.indexOf(billerID) > -1;
        // Keep track of added "Billers" so that we don't show them twice.
        if(!didAddBillerView) {
            addedBillerViewIDs.push(bill.biller.id);
        }

        //console.log(Bill.initAll())

        const showBillerView = billerValidStatus && lastPayment && billerIsAdded && !billerHasDueBills && !didAddBillerView;
        const group = props.group;
       
        const billerInGroup = (biller)=>{
          
            if (group === "default"){
                return biller.billerGroup === undefined;
            }else{
               if( biller.billerGroup !== undefined){
                return group !== undefined ? biller.billerGroup.id === group:true; 
               }else{
                return group == undefined ;
               }
                
            }
        } 
        if(showBillerView && billerInGroup(bill.biller)) {
            result[lastPayment.status].push(
                <BillerView
                    key={ "biller_" + bill.biller.id + "_bill_" + bill.id }
                    biller={ bill.biller }
                    className={ isIncluded ? "selected-biller-view paid-upcoming-biller-view" : "paid-upcoming-biller-view" }
                    checkbox={ <UICheckbox value={ isIncluded } onChange={ value => toggleAdd(value, bill.id) }
                                dataPoint={`My_Billers_Biller_Checkbox_${ bill.biller.id }`}/> }
                    showPaymentInfoBottom={ !(lastPayment.status.toLowerCase() === "canceled") }
                    dataPoint={ `My_Billers_Biller` }
                    bottomPaymentInfo={
                        // <BillerPaymentView
                        //     lastPayment={ lastPayment }
                        //     amount={ lastPayment.amount }
                        //     status={ lastPayment.status }
                        //     date={ lastPayment.formatDate }
                        //     payment={ lastPayment }
                        //     dataPoint={ `My_Billers_Payment` }
                        //     description="Last Payment" />
                        <BottomPaymentInfo 
                            description="Last Payment"
                            amount={ lastPayment.amount }
                            showAutopay={ hasAutopays }
                            status={ lastPayment.status }
                            date={ lastPayment.formatDate }
                            dataPoint={ `My_Billers_Payment`}
                            payment={ lastPayment } />
                    }
                    buttons={
                        <>
                            { !isIncluded &&
                                <ButtonContainer className="set-width">
                                    <UIButton className={ `secondary-button ${ disabledClass }` } onClick={ onClick }
                                    dataPoint={ `My_Billers_Button_Biller_${ bill.biller.id }` }>Pay</UIButton>
                                </ButtonContainer> }

                            { isIncluded &&
                                <ButtonContainer className="set-width">
                                    <UIButton 
                                        className="primary-button multipay-btn" 
                                        dataPoint={ `My_Billers_Button_Biller_${ bill.biller.id }` }
                                        onClick={ submit }>Pay { state.length } biller{ state.length > 1 ? "s" : "" }</UIButton>
                                </ButtonContainer> }
                        </>
                    }
                    upsell={ props.getUpSale(bill) } />
            );
        }

        return result;
    }, { "scheduled" : [], "processed" : [], "processing" : [], "canceled": [] } );

    const bills = [ ...scheduled, ...processing, ...processed, ...canceled ];
    return <> { bills } </>;
}